import React from 'react';
import { Link } from 'react-router-dom';
import { FaChevronRight, FaHome } from 'react-icons/fa';
import './Breadcrumbs.css';

const Breadcrumbs = ({ items }) => {
  return (
    <nav aria-label="breadcrumb" className="breadcrumbs">
      <ol className="breadcrumb-list">
        <li className="breadcrumb-item">
          <Link to="/">
            <FaHome /> Home
          </Link>
        </li>
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <li className="breadcrumb-separator">
              <FaChevronRight />
            </li>
            <li className={`breadcrumb-item ${index === items.length - 1 ? 'active' : ''}`}>
              {item.link && index !== items.length - 1 ? (
                <Link to={item.link}>{item.label}</Link>
              ) : (
                <span>{item.label}</span>
              )}
            </li>
          </React.Fragment>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
